import { trigger, transition, query, style, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { Camera } from '@classes/camera/camera';
import { DashBoardInfos } from '@classes/dashboard/dashboard';
import { faSearch, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { CamerasService } from '@services/cameras/cameras.service';
import { CompareDateService } from '@services/compare-date/compare-date.service';
import { DashbordService } from '@services/dashboard/dashbord.service';
import { ExportExcelFileService } from '@services/export-excel-file/export-excel-file.service';

@Component({
  selector: 'app-car-suction-cup',
  templateUrl: './car-suction-cup.component.html',
  styleUrls: ['./car-suction-cup.component.scss'],
  animations: [
    trigger('show', [
      transition(':enter', [
        query('.divChart', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ], { optional: true })
      ]),
    ]),
  ]
})

export class CarSuctionCupComponent implements OnInit {

  faSearch = faSearch;
  faFileExcel = faFileExcel;


  choiceDateForm: UntypedFormGroup;

  loading = false;

  camera: Camera[];
  today = new Date();

  color: ThemePalette = 'primary';
  datas: DashBoardInfos;
  datasDayHour: DashBoardInfos[];

  tag = 'week';

  barChartOptions = {
    responsive: true,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 50
      },

    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
        }
      }]
    }

  };
  barChartLabels: string[] = [];
  colorLabel: string[] = [];
  colorLabelHover: string[] = [];
  barChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [];

  barChartData = [];

  daysGraph: any[];
  daysSelected: any[];
  dayWeekLib = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

  dateDiff: number;



  constructor(
    private cameraService: CamerasService,
    private dashboardService: DashbordService,
    private formBuilder: UntypedFormBuilder,
    private exportExportExecelFileService: ExportExcelFileService,
    private compareDate: CompareDateService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getCameras();
  }

  onSubmit(changeCamera: boolean): void {

    this.loading = true;
    const newDate = {
      camera: this.choiceDateForm.get('cameraId').value,
      from: this.choiceDateForm.get('from').value,
      to: this.choiceDateForm.get('to').value,
    };

    const cameraId = this.camera.find(item => item.name === this.choiceDateForm.get('cameraId').value).id;

    switch (this.tag) {
      case 'week':
        this.getDashBoardInfos(cameraId, newDate.from, newDate.to, changeCamera);

        break;
      case 'day/hour':
        this.getInfosCarSuctionByHour(cameraId, newDate.from, newDate.to, changeCamera);

        break;

      default:
        break;
    }
    this.dateDiff = this.compareDate.compareTwoDate(newDate.from, newDate.to);



  }

  setTag(tag: string): void {
    this.tag = tag;

    const from = this.formatDate(this.f.from.value);
    const to = this.formatDate(this.f.to.value, true);

    // if (tag === 'day/hour') {
    //   this.getInfosCarSuctionByHour(this.f.cameraId.value, from, to);
    // }
  }

  exportexcel(): void {
    const cameraId = this.choiceDateForm.get('cameraId').value;
    const from = this.formatDate(this.choiceDateForm.get('from').value);
    const to = this.formatDate(this.choiceDateForm.get('to').value);

    let count = 0;

    const excelFile = [{
      Camera: cameraId,
      From: from,
      To: to,
      'Total de voiture': this.datas.maxValue,
      Dimanche: 0,
      Lundi: 0,
      Mardi: 0,
      Mercredi: 0,
      Jeudi: 0,
      Vendredi: 0,
      Samedi: 0,
    }];

    this.datas.data.forEach(day => {
      count += day.value;

      switch (day.label) {
        case 'Dimanche':
          excelFile[0].Dimanche = day.value;
          break;
        case 'Lundi':
          excelFile[0].Lundi = day.value;
          break;
        case 'Mardi':
          excelFile[0].Mardi = day.value;
          break;
        case 'Mercredi':
          excelFile[0].Mercredi = day.value;
          break;
        case 'Jeudi':
          excelFile[0].Jeudi = day.value;
          break;
        case 'Vendredi':
          excelFile[0].Vendredi = day.value;
          break;
        case 'Samedi':
          excelFile[0].Samedi = day.value;
          break;

        default:
          break;
      }
    });

    excelFile[0]['Total de voiture'] = count;

    this.exportExportExecelFileService.exportAsExcelFile(excelFile, cameraId);
  }

  changeValueInputFrom(): void {
    const dateFrom = new Date(this.choiceDateForm.get('from').value).getTime();
    const dateTo = new Date(this.choiceDateForm.get('to').value).getTime();

    const date = new Date(this.choiceDateForm.get('to').value);
    date.setDate(date.getDate() - 7);

    if (dateTo <= dateFrom) {
      this.choiceDateForm.get('from').setValue(date);

    }
  }

  selectedOrNot(day: string): void {
    const dSelect = document.getElementById(`${day}`);
    dSelect.style.display !== 'none' ? dSelect.style.display = 'none' : dSelect.style.display = 'block';
  }

  setDateFrom(): void {
    const dateTo = new Date(this.choiceDateForm.get('to').value);
    const dateFrom = new Date(dateTo.setDate(dateTo.getDate() - 7));

    this.f.from.setValue(dateFrom);
    this.onSubmit(false);
  }

  sendDateTo(index: number): Date {
    const date = new Date(this.f.from.value);
    const newDate = new Date(date.setDate(date.getDate() + index));

    return newDate;
  }

  get f() {
    return this.choiceDateForm?.controls;
  }

  private getCameras(): void {
    this.cameraService.getCameras().subscribe(res => {
      this.camera = res;
      this.choiceDateForm.get('cameraId').setValue(this.camera[0].name);

      const date = new Date();
      date.setDate(date.getDate() - 7);

      this.getDashBoardInfos(this.camera[0].id, date, this.today.toString());
      this.getInfosCarSuctionByHour(this.camera[0].id, date, this.today.toString());
    });
  }

  private getInfosCarSuctionByHour(id: string, from: any, to: string, changeCamera?: boolean): void {
    let dataWithoutOrder = [];
    this.loading = false;


    from = this.formatDate(from);
    to = this.formatDate(to, true);

    const date1 = new Date(from);
    const date2 = new Date(to);
    date2.setHours(23);
    date2.setMinutes(59);

    const diff = this.compareDate.compareTwoDate(date1, date2);

    const allDaysIndex: number[] = [];

    for (let i = 0; i < diff; i++) {
      allDaysIndex.push(date1.getDay());
      date1.setDate(date1.getDate() + 1);
    }


    setTimeout(() => {
      this.dashboardService.getInfosCarSuctionByHour(id, from, to).subscribe(res => {
        this.loading = true;
        this.datasDayHour = [];
        this.daysGraph = [];
        this.daysSelected = [];
        res.forEach((item, index) => {

          if (diff >= 8) {
            this.daysGraph.push(item.label);
            dataWithoutOrder = res;
          } else {
            const dayIndex = allDaysIndex.findIndex(d => d === index);
            if (dayIndex !== -1) {
              this.daysGraph.push(item.label);
              dataWithoutOrder.push(item);
            }
          }
        });

        for (const i of allDaysIndex) {
          const indexDay = dataWithoutOrder.findIndex(d => d.label === this.dayWeekLib[i]);
          const indexDayValue = dataWithoutOrder.find(d => d.label === this.dayWeekLib[i]);
          this.daysSelected.push(this.dayWeekLib[i]);

          if (indexDay !== -1) { this.datasDayHour.push(dataWithoutOrder[indexDay]); }
          if (this.datasDayHour.length === 7) { break; }
        }


        if (changeCamera) {
          setTimeout(() => {
            const inputs = document.querySelectorAll('input');
            inputs.forEach(el => {
              if (el.type === 'checkbox' && el.checked === false) {
                const day = el.id.split('-');
                const graph = document.getElementById(`${day[0]}`);
                if (graph !== null) {

                  graph.style.display = 'none';

                }
              }
            });
          }, 500);
        }

      });

    }, 2000);
  }

  private getDashBoardInfos(id: string, from: any, to: string, changeCamera?: boolean): void {

    from = this.formatDate(from);
    to = this.formatDate(to, true);
    this.loading = false;
    this.barChartLabels = [];
    this.barChartData = [];

    this.dashboardService.getInfosCarSuction(id, from, to).subscribe(res => {
      this.datas = res;

      res.data.forEach(l => {
        this.barChartLabels.push(l.label);
        this.barChartData.push(l.value);
      });

      this.barChartData = [
        { data: this.barChartData, backgroundColor: '#0075c8b2', hoverBackgroundColor: '#0074c8', label: res.label },
      ];

      this.loading = true;

    });
  }

  private formatDate(date, to?: boolean): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }

    return [year, month, day].join('-');
  }

  private initForm(): void {
    const date = new Date();
    date.setDate(date.getDate() - 7);

    this.choiceDateForm = this.formBuilder.group({
      cameraId: ['', Validators.required],
      from: [date, Validators.required],
      to: [this.today, Validators.required]
    });

    this.dateDiff = this.compareDate.compareTwoDate(date, this.today);

  }


}
